
import type { ContatoProjeto } from "../../../services/contato.service";

interface ContatosSectionProps {
  contatos: ContatoProjeto[];
}

export function ContatosSection({ contatos }: ContatosSectionProps) {
  if (contatos.length === 0) return null;

  return (
    <section className="mb-8" style={{ pageBreakBefore: "always", breakBefore: "page" }}>
      <h2 className="text-xl font-black text-gray-900 mb-4 uppercase tracking-wide border-b-2 border-gray-800 pb-2">
        Lista de contatos de responsáveis
      </h2>
      <table className="contatos-table w-full border-collapse text-sm">
        <thead>
          <tr className="bg-gray-100">
            <th className="text-left px-3 py-2 border border-gray-300 font-semibold">Nome</th>
            <th className="text-left px-3 py-2 border border-gray-300 font-semibold">Cargo / Função</th>
            <th className="text-left px-3 py-2 border border-gray-300 font-semibold">Empresa</th>
            <th className="text-left px-3 py-2 border border-gray-300 font-semibold">Telefone</th>
            <th className="text-left px-3 py-2 border border-gray-300 font-semibold">E-mail</th>
          </tr>
        </thead>
        <tbody>
          {contatos.map((c) => (
            <tr key={c.id} style={{ breakInside: "avoid", pageBreakInside: "avoid" }}>
              <td className="px-3 py-2 border border-gray-300 font-medium">{c.nome}</td>
              <td className="px-3 py-2 border border-gray-300 text-gray-600">{c.cargo || "—"}</td>
              <td className="px-3 py-2 border border-gray-300 text-gray-600">{c.empresa || "—"}</td>
              <td className="px-3 py-2 border border-gray-300 text-gray-600">{c.telefone || "—"}</td>
              <td className="px-3 py-2 border border-gray-300 text-gray-600">{c.email || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
